import { _ } from 'core-js';
import cookie from 'js-cookie';
import COOKIE_KEYS from '../../configs/app.cookie';
import { post, API } from '../../net/http';
export default {
  namespaced: true,
  state: {
    userName: '',
    userInfo: {},
    cookiePrivacy: true,
    insurances: [],
  },
  mutations: {
    checkAppConfig(state) {
      let privacy = !!cookie.get(COOKIE_KEYS.privacy);
      setTimeout(() => {
        state.cookiePrivacy = privacy;
      }, 400);
    },
    agreeCookiePrivacy(state) {
      state.cookiePrivacy = true;
      cookie.set(COOKIE_KEYS.privacy, 1);
    },
    logout(state) {
      state.userName = '';
    },
    login(state, userInfo) {
      state.userName = userInfo.userName;
      state.userInfo = userInfo;
    },
    setAppConfig(state, { key, val }) {
      if (_.hasIn(state, key)) {
        state[key] = val;
      }
    },
  },
  actions: {
    checkAppConfig({ commit }) {
      commit('checkAppConfig');
      return post(API.userUserInfo).then(res => {
        if (res.success) {
          commit('login', res.data);
        }
      });
    },
  },
};
